<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.499"
      height="19.563"
      viewBox="0 0 21.499 19.563"
      class="scaling-svg"
    >
      <g transform="translate(-50.5 -340.937)">
        <g transform="translate(49 344)">
          <g transform="translate(1.5 1.5)">
            <path
              d="M14.25,15H.75A.751.751,0,0,1,0,14.25v-9a.749.749,0,0,1,.334-.624l6.75-4.5a.749.749,0,0,1,.832,0l6.75,4.5A.748.748,0,0,1,15,5.25v9A.751.751,0,0,1,14.25,15ZM1.5,6.651V13.5h12V6.651L7.916,10.374a.749.749,0,0,1-.832,0Zm6-5L2.1,5.25l5.4,3.6,5.4-3.6-5.4-3.6Z"
              fill="#534d69"
            />
          </g>
        </g>
        <g transform="translate(-115.887 -298.136)">
          <g transform="translate(173.887 639.073)">
            <path d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Z" transform="translate(0 0)" fill="#534d69" />
          </g>
          <path
            d="M5.833,3.792H3.792V5.833a.583.583,0,0,1-1.167,0V3.792H.583a.583.583,0,1,1,0-1.167H2.625V.583a.583.583,0,0,1,1.167,0V2.625H5.833a.583.583,0,1,1,0,1.167Z"
            transform="translate(177.679 642.864)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class NewDocumentIcon extends Vue {}
</script>

<style>
</style>
